<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21.5" height="15.5" viewBox="0 0 21.5 15.5">
    <g id="menu" transform="translate(-0.25 -4.25)">
      <line
        id="Line_555"
        data-name="Line 555"
        x2="20"
        transform="translate(1 12)"
        fill="none"
        stroke="currentcolor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5" />
      <line
        id="Line_556"
        data-name="Line 556"
        x2="20"
        transform="translate(1 5)"
        fill="none"
        stroke="currentcolor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5" />
      <line
        id="Line_557"
        data-name="Line 557"
        x2="20"
        transform="translate(1 19)"
        fill="none"
        stroke="currentcolor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5" />
    </g>
  </svg>
</template>
